export default __webpack_public_path__ + "static/media/Heaven Cracker Earth Breaker.8a70423b.jpg";